export default {
    'Sackers': {
        'Heavy': {
            fontFamily: 'SackersGothicStd-Heavy',
            fontWeight: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.5',
            letterSpacing: '0.05rem',
            textTransform: 'uppercase'
        },
        'Medium': {
            fontFamily: 'SackersGothicStd-Medium',
            fontWeight: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.5',
            letterSpacing: '0.05rem',
            textTransform: 'uppercase'
        },
        'Light': {
            fontFamily: 'SackersGothicStd-Light',
            fontWeight: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.5',
            letterSpacing: '0.05rem',
            textTransform: 'uppercase'
        },
    },
    'Granjon': {
        'Italic': {
            fontFamily: 'GranjonLTStd-Italic',
            fontWeight: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.2'
        },
        'Bold': {
            fontFamily: 'GranjonLTStd-Bold',
            fontWeight: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.2'
        },
        'Normal': {
            fontFamily: 'GranjonLTStd',
            fontWeight: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.2'
        }
    },
    'Icons': {
        fontFamily: 'icons',
        lineHeight: '1'
    }
};


// WEBPACK FOOTER //
// ./src/constants/fonts.ts